import type { FC } from 'react';
import styled from 'styled-components';

type RulesProps = {
  rule: string;
};

type RuleListProps = {
  title: string;
  rules: RulesProps[];
  content: string | undefined;
};

type RulesListProps = {
  list: RuleListProps[];
};

export const RulesSection: FC<RulesListProps> = ({ list }) => (
    <RulesItems>
      {list.map((item) => (
          <Section key={item.title}>
            <RulesTitle>{item.title}</RulesTitle>
            <ol>
              {item.rules.map((rule, index) => <li key={index} dangerouslySetInnerHTML={{ __html: rule.rule }} />)}
            </ol>
            {item?.content && <p dangerouslySetInnerHTML={{ __html: item?.content }} />}
          </Section>
        ))}
    </RulesItems>
  );

const RulesItems = styled.div`
  display: grid;
`;

const RulesTitle = styled.div`
  font-size: 17px;
  line-height: 20px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #111;
`;

const Section = styled.div`
  margin-bottom: 16px;
`;
